import { render, staticRenderFns } from "./c-content-chart-radius-pie@.vue?vue&type=template&id=f371c0c8&scoped=true&"
import script from "./c-content-chart-radius-pie@.vue?vue&type=script&lang=ts&"
export * from "./c-content-chart-radius-pie@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f371c0c8",
  null
  
)

export default component.exports